import React, { useState, useEffect } from 'react';
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert } from 'react-bootstrap';
import dateFormat from 'dateformat';
import ClientCrudService from '../../services/ClientCrudService';
import ProviderTypeService from '../../services/ProviderTypeService';
import Spinner from '../utils/Spinner';
import InputText from '../../components/Forms/InputText'

const ModalNewSite = ({ show, handleClose, setRenderRows, userToken }) => {
    const providerTypeOptions = ProviderTypeService.getAllProviders();
    const [suscriptionsPlans, setSuscriptionsPlans] = useState([]);
    const [getAllPlans, setGetAllPlans] = useState([]);
    const [suscriptionCode, setSuscriptionCode] = useState('');
    const [suscriptionExpires, setSuscriptionExpires] = useState(null);
    const [successUser, setSuccessUser] = useState(null);

    const defaultSiteData = {
        validUserId: '',
        name: '',
        urlName: '',
        providerType: 'T1PAGINAS',
        storeHouse: {
            name: '',
            email: '',
            phone: '',
            address: {
                country: '',
                state: '',
                municipality: '',
                city: '',
                postalCode: '',
                street: '',
                outNumber: '',
                intNumber: '',
                suburb: ''
            }
        },
        subscription: {
            id: '',
            plan_id: '',
            cliente_id: '',
            code: 0,
            price: 0,
            frequency: 0,
            periodType: ''
        }
    };

    const [validUserId, setValidUserId] = useState('');
    const [validUserCreate, SetValidUserCreate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [enableSaveChanges, setEnableSaveChanges] = useState(true);

    const [siteData, setSiteData] = useState(defaultSiteData);

    useEffect(() => {

        ClientCrudService.getAllPlans().then(async res => {
            setGetAllPlans(res.data.data);
        });

        if (!show) {
            setSiteData(defaultSiteData);
            setValidUserId('');
            SetValidUserCreate(false);
            setEnableSaveChanges(true);
            setSuscriptionCode('');
            setSuscriptionsPlans([]);
            setSuccessUser(null);
        }
    }, [show]);

    function sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time)
        )
    }

    const formFieldsHandler = (event) => {
        switch (event.target.name) {

            case 'Name': handlerCreateUrlName(event.target.value); break;
            case 'ProviderType': setSiteData({ ...siteData, providerType: event.target.value }); break;
            case 'StoreName': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, name: event.target.value } }); break;
            case 'StoreEmail': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, email: event.target.value } }); break;
            case 'StorePhone': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, phone: event.target.value } }); break;
            case 'Country': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, country: event.target.value } } }); break;
            case 'State': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, state: event.target.value } } }); break;
            case 'Municipality': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, municipality: event.target.value } } }); break;
            case 'City': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, city: event.target.value } } }); break;
            case 'PostalCode': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, postalCode: event.target.value } } }); break;
            case 'Street': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, street: event.target.value } } }); break;
            case 'OutNumber': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, outNumber: event.target.value } } }); break;
            case 'IntNumber': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, intNumber: event.target.value } } }); break;
            case 'Suburb': setSiteData({ ...siteData, storeHouse: { ...siteData.storeHouse, address: { ...siteData.storeHouse.address, suburb: event.target.value } } }); break;
            case 'Subscription.id': setSiteData({ ...siteData, subscription: { ...siteData.subscription, id: event.target.value } }); break;
            case 'Subscription.plan_id': setSiteData({ ...siteData, subscription: { ...siteData.subscription, plan_id: event.target.value } }); break;
            case 'Subscription.cliente_id': setSiteData({ ...siteData, subscription: { ...siteData.subscription, cliente_id: event.target.value } }); break;

            default: break;
        }

        setEnableSaveChanges(false);
    }

    const handleSubmit = async (event) => {
        console.log('handleSubmit [siteData] :', siteData);
        setIsLoading(true);

        if (siteData.name === '' || siteData.urlName === '' || siteData.providerType === '' || siteData.storeHouse.name === '' || siteData.storeHouse.email === '' || siteData.storeHouse.phone === '' || !siteData.subscription.code) {
            setIsLoading(false);
        } else {
            ClientCrudService.createNewSite(siteData).then(res => {
                sleep(1500).then(() => {
                    setIsLoading(false);
                    handleClose();
                    setRenderRows();
                });
            }).catch(error => {
                console.log(error);
                setIsLoading(false);
            });
        }
    };

    const fetchData = async () => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userToken
            }
        };
    
        try {
            const response = await fetch(`${process.env.REACT_APP_NERTHUS_API_URL}/clients/identity/storeUser/${validUserId}`, requestOptions);
    
            if (response.ok) {
                const json = await response.json();
                handleFetchSuccess(json);
            } else {
                handleFetchError();
            }
    
        } catch (error) {
            console.log(error);
            handleFetchError();
        } finally {
            setIsLoading(false);
        }
    };
    
    const handleFetchSuccess = (json) => {
        if (json.data && json.data.length > 0) {
            const userData = json.data[0];
            updateSiteData(userData);
            SetValidUserCreate(true);
            setSuccessUser('success');
        } else {
            handleFetchError();
        }
    };
    
    const handleFetchError = () => {
        SetValidUserCreate(false);
        setSuccessUser('danger');
    };
    
    const updateSiteData = (userData) => {
        setSiteData((prevData) => ({
            ...prevData,
            validUserId: validUserId,
            storeHouse: {
                ...prevData.storeHouse,
                name: userData.name,
                email: userData.email,
            },
        }));
    };
    
    const handlerCreateClient = async (event) => {
        setIsLoading(true);
    
        sleep(1000).then(() => {
            console.log('validUserId => ' + validUserId);
            fetchData();
        });
    };

    const changeValidUserId = (event) => {
        setValidUserId(event.target.value);
    }

    const handlerCreateUrlName = (valueName) => {

        let clearName = valueName.toLowerCase();
        clearName = clearName.normalize("NFKD").replace(/[^\w-]/gi, '')

        setSiteData((prevData) => ({
            ...prevData,
            urlName: clearName,
            name: valueName,
        }));

    }

    const changeSuscriptionCodeHandler = (event) => {
        setSuscriptionCode(event.target.value);
        setSiteData({ ...siteData, subscription: { ...siteData.subscription, code: event.target.value } });
        let plan = getAllPlans.find((obj) => obj['code'] == event.target.value);
        setSuscriptionsPlans(plan.suscriptions);
    }

    const changePlanPeriodHandler = (event) => {

        const current = new Date();
        let indexPeriod = event.target.value;
        const freqPer = indexPeriod.split('_');

        const numPeriod = Number(parseInt(freqPer[1], 10));

        if (freqPer[0] == 'month') {
            current.setMonth((current.getMonth() + numPeriod));
        }

        if (freqPer[0] == 'year') {
            current.setMonth((current.getMonth() + (12 * numPeriod)));
        }

        setSuscriptionExpires(current);
        setSiteData({ ...siteData, subscription: { ...siteData.subscription, price: freqPer[2], frequency: freqPer[1], periodType: freqPer[0] } });
    }

    const tabFooter = (<>** All fields are required.<hr style={{ margin: '0.5rem' }}></hr>
        <Button type="button" disabled={enableSaveChanges} onClick={handleSubmit}>Save</Button>
        {'  '}  {'  '}
        <Button variant="secondary" onClick={handleClose}>
            Close
        </Button></>);

    return (
        <>
            <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title> Create New Site
                        {validUserCreate ? <span style={{ color: 'green' }}> By {siteData.storeHouse.email} </span> : null}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading ? <Spinner /> : null}
                    {(!validUserCreate) ?
                        <div>
                            Validar Usuario a Asignar:
                            <InputText defaultValue={validUserId} label={'validUserId'} handler={changeValidUserId} conditionView={false} width={'8'} />
                            <hr>
                            </hr>
                            {(successUser == 'danger') ? (<Alert key='danger' variant='danger'> ¡Not Found, Check UserId or Try later!</Alert>)
                                : (successUser == 'success') ? (<Alert key='success' variant='success'> Get User Success!</Alert>) : ""}

                            <Button variant="primary" onClick={() => handlerCreateClient()} >
                                Validar
                            </Button> {'  '}  {'  '}
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                        </div>
                        :
                        <div>

                            <Tabs
                                defaultActiveKey="main"
                                id="justify-tab-example"
                                className="mb-3"
                                justify
                            >
                                <Tab eventKey="main" title="Data Client">

                                    <Row className="mb-3">

                                        <InputText defaultValue={siteData.name} label={'Name'} handler={formFieldsHandler} conditionView={false} width={'8'} />

                                        <Form.Group as={Col} md="4" controlId="validCustom7">
                                            <Form.Label>ProviderType</Form.Label>
                                            <Form.Select
                                                name="ProviderType"
                                                required="ProviderType is required"
                                                onChange={formFieldsHandler}
                                                readOnly={false}
                                                value={siteData.providerType}>

                                                {providerTypeOptions.map((itemRole) => {
                                                    return (<option key={itemRole} value={itemRole}>{itemRole}</option>)
                                                })}

                                            </Form.Select>
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-3">

                                        <InputText defaultValue={siteData.urlName} label={'UrlName'} handler={formFieldsHandler} conditionView={true} width={'6'} />
                                    </Row>

                                    <hr></hr>
                                    <b>Store House</b>

                                    <Row className="mb-3">
                                        <InputText defaultValue={siteData.storeHouse.name} label={'StoreName'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={siteData.storeHouse.email} label={'StoreEmail'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={''} label={'StorePhone'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                    </Row>

                                    <Row className="mb-3">
                                        <InputText defaultValue={''} label={'Country'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={''} label={'State'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={''} label={'Municipality'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                    </Row>

                                    <Row className="mb-3">
                                        <InputText defaultValue={''} label={'City'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={''} label={'PostalCode'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={''} label={'Street'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                    </Row>

                                    <Row className="mb-3">
                                        <InputText defaultValue={''} label={'OutNumber'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={''} label={'IntNumber'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={''} label={'Suburb'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                    </Row>

                                    {tabFooter}
                                </Tab>

                                <Tab eventKey="changeplan" title="Plan">
                                    <Row className="mb-2">

                                        <Form.Group as={Col} md="4" key={1}>
                                            <Form.Label>Suscription PLAN</Form.Label>
                                            <Form.Select
                                                required="Plan Type is required"
                                                onChange={changeSuscriptionCodeHandler}
                                                value={suscriptionCode}
                                            >
                                                <option>Select</option>
                                                {getAllPlans.map((itemRole) => {
                                                    return (<option key={itemRole.code} value={itemRole.code}>{itemRole.name}</option>)
                                                })}

                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group as={Col} md="4" key={2}>
                                            <Form.Label>Period PLAN </Form.Label>
                                            <Form.Select
                                                required="Period is required"
                                                onChange={changePlanPeriodHandler}
                                            >
                                                <option>Select</option>
                                                {suscriptionsPlans.map((itemRole, index) => {
                                                    return (<option key={itemRole.price + index} value={(itemRole.periodType + '_' + itemRole.frequency + '_' + itemRole.price)}> By {itemRole.frequency + ' ' + itemRole.periodType + ' Price $' + itemRole.price}</option>)
                                                })}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group as={Col} md="4" key={3}>
                                            <Form.Label>Suscription Expires</Form.Label>
                                            <Form.Control
                                                type="date"
                                                placeholder="Suscription Expire"
                                                value={(dateFormat(suscriptionExpires, "yyyy-mm-dd", true))}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Form.Group>

                                    </Row>

                                    <hr></hr>
                                    <b> T1 Pagos </b>

                                    <Row className="mb-3">
                                        <InputText defaultValue={siteData.subscription.id} label={'Subscription.id'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={siteData.subscription.plan_id} label={'Subscription.plan_id'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                        <InputText defaultValue={siteData.subscription.cliente_id} label={'Subscription.cliente_id'} handler={formFieldsHandler} conditionView={false} width={'4'} />
                                    </Row>

                                    {tabFooter}
                                </Tab>
                            </Tabs>

                        </div>}

                </Modal.Body>
            </Modal>
        </>
    );
}

export default ModalNewSite;